
import React from 'react';
import { Checkbox } from 'office-ui-fabric-react/lib/Checkbox';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import get from 'lodash/get';

import { IfComp } from '../../../core';

import ObjectEditAttribute from './ObjectEditAttribute';

const ObjectEditor = ({
    dataModel,
    mode,
    object,
    onChange
}) => {

    const classNames = mergeStyleSets({
        ObjectEditor: {
        },
        title: {
            paddingTop: 4,
            paddingBottom: 4,
            fontWeight: 'bold',
            color: '#999999'
        },
        attributes: {
        }
    });

    const [showAllAttrs, setShowAllAttrs] = React.useState(false);

    const isAttributeAllow = (attribute) => {
        switch (mode) {
            case 'insert':
                return isAttributeAllowInsert(attribute);
            case 'update':
                return isAttributeAllowUpdate(attribute);
            default:
                return false;
        }
    }

    const isAttributeAllowInsert = (attribute) => {
        let allow = !attribute.generated;
        return allow;
    }

    const isAttributeAllowUpdate = (attribute) => {
        let allow = !attribute.generated;
        const allowAttributes = get(dataModel, 'operations.update.allowAttributes');
        if (allowAttributes) {
            allow = allow && (allowAttributes.indexOf(attribute.name) !== -1);
        }
        return allow
    }

    const isNeedAllAttributes = () => {
        let need = false;
        const allowAttributes = get(dataModel, 'operations.update.allowAttributes');
        if (allowAttributes && (mode === 'update')) {
            need = true;
        }
        return need;
    }

    const handleChangeShowAllAttrs = (event, checked) => {
        setShowAllAttrs(checked);
    }

    const handleChangeAttributeValue = (attrName, value) => {
        if (onChange) {
            onChange(attrName, value);
        }
    }

    return (
        <Stack className={classNames.ObjectEditor} tokens={{childrenGap: 8}}>
            <Stack.Item className={classNames.title}>{dataModel.title}</Stack.Item>
            <Stack className={classNames.attributes}>
                {dataModel.attributes.map(item => {
                    const allowAttr = isAttributeAllow(item);
                    if (allowAttr || showAllAttrs) {
                        let value = object.attributes[item.name];
                        if (value === null) {
                            value = undefined;
                        }
                        return (
                            <ObjectEditAttribute
                                allow={allowAttr}
                                attribute={item}
                                dataModel={dataModel}
                                key={item.name}
                                mode={mode}
                                onChange={handleChangeAttributeValue}
                                value={value}
                            />
                        );
                    } else {
                        return null;
                    }
                })}
            </Stack>
            <Stack.Item>
                <IfComp cond={isNeedAllAttributes()}>
                    <Checkbox
                        label="Zobrazit všechny atributy"
                        checked={showAllAttrs}
                        onChange={handleChangeShowAllAttrs}
                    />
                </IfComp>
            </Stack.Item>
        </Stack>
    );
}

export default ObjectEditor;
